import type { ExperimentConfig } from '../@types'
import type { UpsellRoute } from '@/@types/router-types'

const supplementsUpsellRouteNames: UpsellRoute[] = [
	'upsell-static-supplements-intro',
	'upsell-static-supplements-onboarding',
	'upsell-static-supplements-offer',
	'upsell-static-supplements-checkout',
	'upsell-static-supplements-preview',
	'upsell-static-supplements-result',
]

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_upsell_supplements_peptides~1
			upsell: {
				routeNames: supplementsUpsellRouteNames,
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_upsell_supplements_peptides~1
			upsell: {
				routeNames: supplementsUpsellRouteNames,
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_upsell_supplements_peptides~1
			upsell: {
				routeNames: supplementsUpsellRouteNames,
			},
		},
	},
]

export default config
